const FORGOT_PASSWORD = "/auth/forgot_password";

export const forgotPassword = { FORGOT_PASSWORD };
